const TriggerRemoveIcon = () => (
	<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M1.55554 4.63892H10.4444V11.7222C10.4444 12.3359 9.94697 12.8334 9.33332 12.8334H2.66665C2.053 12.8334 1.55554 12.3359 1.55554 11.7222V4.63892Z" stroke="#D14545" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M1 2.55551H3.77778L4.16944 1.52484C4.25138 1.30919 4.45807 1.16663 4.68876 1.16663H7.31124C7.54193 1.16663 7.74862 1.30919 7.83057 1.52484L8.22222 2.55551H11" stroke="#D14545" strokeLinecap="round" strokeLinejoin="round" />
	</svg>

);

export default TriggerRemoveIcon;